import { addDays, isSameDay, parseISO } from 'date-fns';
import type { TimelineAbsenceBlock, TimelineAbsenceDayDto } from '../types';

/**
 * The backend returns absences as a flat `(userId, date)` list, deliberately
 * ungrouped (see the timeline integration guide). Merges consecutive dates for
 * the same person into visual blocks — one bar per contiguous run, matching
 * the "Vacaciones" bar in the design instead of one sliver per day.
 */
export function groupConsecutiveAbsences(
  absences: TimelineAbsenceDayDto[],
): TimelineAbsenceBlock[] {
  const byUser = new Map<string, Date[]>();
  for (const absence of absences) {
    const dates = byUser.get(absence.userId) ?? [];
    dates.push(parseISO(absence.date));
    byUser.set(absence.userId, dates);
  }

  const blocks: TimelineAbsenceBlock[] = [];
  for (const [userId, dates] of byUser) {
    const sorted = [...dates].sort((a, b) => a.getTime() - b.getTime());

    let blockStart = sorted[0];
    let blockEnd = sorted[0];

    for (let i = 1; i < sorted.length; i++) {
      const current = sorted[i];
      if (isSameDay(current, addDays(blockEnd, 1))) {
        blockEnd = current;
        continue;
      }
      blocks.push({ userId, startDate: blockStart, endDate: blockEnd });
      blockStart = current;
      blockEnd = current;
    }
    blocks.push({ userId, startDate: blockStart, endDate: blockEnd });
  }

  return blocks;
}
